// 데스크톱 / 안드로이드 크롬 브라우저에 웹 앱 설치 시 필요한 소스코드 영역
import { useEffect, useState, useCallback } from "react";
import { useSetRecoilState } from "recoil";
import { ToastMessageState } from "../recoil/states";
import CommonUtil from "../utils/CommonUtil";

export function useA2HS() {
  const [canInstall, setCanInstall] = useState(false);
  const [deferred, setDeferred] = useState<any>(null);

  const setToastMessageState = useSetRecoilState(ToastMessageState); // 토스트 메세지 요청 정보를 갖는 state

  useEffect(() => {
    const onBIP = (e: any) => {
      e.preventDefault();
      setDeferred(e);
      setCanInstall(true);
    };
    window.addEventListener('beforeinstallprompt', onBIP);
    return () => window.removeEventListener('beforeinstallprompt', onBIP);
  }, []);

  const promptInstall = useCallback(async () => {
    if (!deferred) return;
    deferred.prompt();

    // 사용자의 선택을 기다림
    const { outcome } = await deferred.userChoice; // { outcome: 'accepted' | 'dismissed', platform: ... }
    if (outcome === "accepted") {
      // '설치' 버튼 클릭
      if (CommonUtil.isMobileOs()) {
        // 모바일 기기일 경우
        const message = "상단 noti바에 설치 진행률이 표시됩니다.";
        setToastMessageState(rawState => ({ ...rawState, isShow: true, message }));
      }
    }

    setDeferred(null);
    setCanInstall(false);
  }, [deferred]);

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && /Safari/.test(navigator.userAgent);
  const isStandalone =
    window.matchMedia?.('(display-mode: standalone)').matches || (window as any).navigator.standalone;

  return { canInstall, promptInstall, isIOS, isStandalone };
}
